import React from 'react';
import useDocumentTitle from '../useDocumentTitle'
import NavbarLearn from '../navbarLearn';
import Sidebar from '../learnSidebar';
import image from "../../img/fourBtoolsizingchart.png"
import poop from "../../img/fourbbolt1.jpg"
import poop2 from "../../img/fourbbolt2.jpg"

export default function FourB() {
    useDocumentTitle("Chapter 4 Lesson B | 101Learn by the Spartabots")
    return (
        <div>
            <NavbarLearn />
            <div class="flex max-w-[100rem] mx-auto my-5 bg-gradient-to-r from-frcyellow to-frcpurple rounded-[2rem] items-center">
                <p class="font-scoutcond font-black italic text-white opacity-50 text-[30rem] ml-10 leading-none">04-B</p>
                <h class="z-20 absolute font-scoutcond font-black italic text-frcblue text-[10rem] ml-40 leading-none">TOOL SIZE GUIDE</h>
                <p class="absolute ml-[9.4rem] mt-44 font-scoutcond font-black italic text-white text-[4rem] leading-none">LESSON 4-B</p>
            </div>
            <div class="flex flex-row max-w-[100rem] mx-auto mb-5">
                <div class="hidden md:flex basis-80 bg-gray-300 rounded-l-[2rem]">
                    <Sidebar />
                </div>
                <div class="basis-full h-full bg-gray-50 rounded-r-[2rem]">
                    <div class="mx-10 my-10">
                        <h class="font-scoutcond font-black italic text-[5rem] leading-none">LESSON OVERVIEW</h>
                        <p class="font-productsans font-bold text-3xl text-gray-400">Understand how tool sizing works.</p>
                        <p class="font-productsans text-base text-black mt-5">You'll be introduced to the imperial and metric tool system in ths lesson - to skip ahead, click on the chapter roadmap below:</p>
                        <a href="/learn/four">
                            <p class="font-avenir font-bold text-base text-frcblue mt-10 leading-none">CHAPTER 4</p>
                            <p class="font-scoutcond font-black text-[3rem] leading-none">MECHANICAL BASICS</p>
                        </a>
                        <div class="border-l-2 ml-5">
                            <ul class="font-productsans font-bold ml-3">
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/a">Tools and Machinery</a>
                                    <p class="font-productsans font-normal ml-3">Learn about common tools in your workshop and how to use them safely.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/b">Tool Size Guide</a>
                                    <p class="font-productsans font-normal ml-3">A reference for sizing - it gets confusing sometimes!</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/c">Gears, Chains, and Belts</a>
                                    <p class="font-productsans font-normal ml-3">Understand how and when to use gears, chains, and belts.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/d">Motors</a>
                                    <p class="font-productsans font-normal ml-3">Learn about the different FRC-legal motors.</p>
                                </li>
                                <li>
                                    <a class="transition-all ease-in-out text-black hover:text-frcblue duration-300" href="/learn/four/e">Drive Trains</a>
                                    <p class="font-productsans font-normal ml-3">Learn about the most important part of your robot - without this, it's useless.</p>
                                </li>
                            </ul>
                        </div>
                        <h class="block font-scoutcond font-black italic text-[5rem] leading-none mt-20">GUIDE TO TOOL SIZES </h>
                        <p class="font-productsans text-lg text-black">Imperial (standard) measurement was adopted in the US, while metric (SI) measurement is used elsewhere in the world. In FRC, most of the parts will require instruments with imperial measurement, but some parts will require metric tools as well. The following table is a rough conversion chart between the two scales, but be aware that some sizes don’t have a perfect conversion. </p>

                        <img src={image} class="my-5 rounded-[1rem]" alt="A chart with common bolt sizes and their conversions"></img>

                        <p class="font-productsans font-bold text-2xl text-black mt-10">Imperial Bolt Sizing</p>
                        <p class="font-productsans text-lg text-frcblue font-bold mt-0">How to read it?</p>
                        <p class="font-productsans text-lg text-black">10-32 x 1 , 1/4-20 x 5/8</p>
                        
                        <p class="font-productsans text-lg text-black">1. Read the first letter of the size. This is the diameter of the threaded area.</p>
                        <p class="font-productsans text-lg text-black">2. Read the second number. This is the number of threads per unit of distance between the threads. Known as thread pitch. </p>
                        <p class="font-productsans text-lg text-black">3. The length of the bolt from the end of the cap to the end of the thread. </p>

                        <p class="font-productsans text-lg text-black">For Example: 1/4-20 x 5/8</p>
                        <p class="font-productsans text-lg text-black">     - The diameter of the screw is 0.25 inches</p>
                        <p class="font-productsans text-lg text-black">     - The thread pitch is 20 threads per inch</p>
                        <p class="font-productsans text-lg text-black">     - The bolt length is 5/8 inches</p>
                        <img src={poop} class="my-5 rounded-[1rem]" alt="1/4 20 bolt"></img>

                        <p class="font-productsans text-lg text-black">What does it mean when when a bolt is 10-21 x 1?</p>
                        <p class="font-productsans text-lg text-black">     - For bolt diameters less than 0.25 inches, their size is indicated by a number(e.g. 8 or 10)</p>
                        <img src={poop2} class="my-5 rounded-[1rem]" alt="A chart with bolt sizes 1-10"></img>

                        
                    
                    </div>
                </div>
            </div>
        </div>
    )
}